import React from 'react';
import './ChiSiamo.css';

const ChiSiamo: React.FC = () => {
  return (
    <section id="chi-siamo">
      <h2>👥 Chi Siamo</h2>
      <p className="lead">Gioco per Tutti è un’associazione culturale no-profit nata dalla passione per il gioco e per la community. Operiamo secondo principi di democraticità, inclusione e rispetto, con l’obiettivo di creare spazi sicuri e accessibili in cui le persone possano incontrarsi, esprimersi e crescere insieme.</p>
      <div className="split">
        <div>
          <h3>La nostra missione</h3>
          <p className="lead" style={{ fontSize: '16px' }}>
            Promuoviamo il gioco come strumento di aggregazione, crescita culturale e solidarietà sociale.
            Attraverso giochi da tavolo, videogame, giochi di ruolo, coding e attività creative, costruiamo esperienze che favoriscono la socializzazione, il benessere psico-fisico e lo sviluppo personale. Crediamo che il gioco non sia solo intrattenimento, ma un potente mezzo educativo e sociale.
          </p>
          <h3 style={{ marginTop: '32px' }}>I nostri valori</h3>
          <ul>
            <li><strong>Inclusività:</strong> tutti sono i benvenuti, indipendentemente da esperienza, età o background</li>
            <li><strong>Rispetto:</strong> ambiente sicuro e positivo per tutti i partecipanti</li>
            <li><strong>Community:</strong> costruiamo relazioni durature attraverso il gioco</li>
            <li><strong>No-profit:</strong> ogni risorsa viene reinvestita per migliorare l'esperienza della community</li>
          </ul>
          <div className="hero-actions" style={{ marginTop: '24px' }}>
            <a
              className="cta"
              href="https://bit.ly/iscriviti-giocopertutti"
              target="_blank"
              rel="noopener noreferrer"
            >
              Unisciti a noi
            </a>
            {/* <a className="cta secondary" href="#volontari" onClick={(e) => { e.preventDefault(); smoothScroll('#volontari'); }}>
              Diventa volontario
            </a> */}
          </div>
        </div>
        {/* <div className="panel">
          <h3>📊 Numeri della community</h3>
          <div className="stats" style={{gridTemplateColumns: '1fr', marginTop: '16px'}}>
            <div className="stat">
              <div style={{fontSize: '28px', marginBottom: '8px'}}>👥</div>
              <strong>800+</strong>
              <p style={{margin: '8px 0 0', fontSize: '14px'}}>Persone nella community</p>
            </div>
            <div className="stat">
              <div style={{fontSize: '28px', marginBottom: '8px'}}>🎯</div>
              <strong>12</strong>
              <p style={{margin: '8px 0 0', fontSize: '14px'}}>Format diversi di eventi</p>
            </div>
            <div className="stat">
              <div style={{fontSize: '28px', marginBottom: '8px'}}>📅</div>
              <strong>50</strong>
              <p style={{margin: '8px 0 0', fontSize: '14px'}}>Eventi all'anno</p>
            </div>
            <div className="stat">
              <div style={{fontSize: '28px', marginBottom: '8px'}}>🤝</div>
              <strong>100%</strong>
              <p style={{margin: '8px 0 0', fontSize: '14px'}}>No-profit e volontariato</p>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default ChiSiamo;



